module.exports = __webpack_public_path__ + "img/item6_bg.6f5f9498.png";